import React from "react";
import { employeeWellBeing } from "../../utils/constants/Team";
import Fade from "react-reveal/Fade";
import CustomNextImage from "../common/CustomNextImage";

const WellBeing = () => {
  return (
    <section>
      <Fade bottom>
        <h6 className="text-[24px] font-lexend font-semibold text-center lg:text-[40px]">
          Employee Well-being
        </h6>
      </Fade>
      <div className="mt-6 md:flex md:gap-x-5">
        {employeeWellBeing.map((item) => {
          return (
            <div
              key={item?.title}
              className="group cursor-pointer flex gap-x-4 items-center rounded-xl first:!mt-0 !mt-5 p-3 bg-black hover-float md:flex-col md:w-[33.3%] md:!mt-0 lg:p-6"
            >
              <div className="w-[20%] md:w-full">
                <CustomNextImage
                  src={item?.icon}
                  alt={item?.title}
                  width={200}
                  height={200}
                  className="w-[60px] transform transition duration-700 ease-in-out group-hover:scale-110 md:w-[70px] md:mx-auto lg:w-[80px]"
                />
              </div>
              <div className="w-[80%] md:w-full lg:mt-2">
                <h6 className="font-lexend font-semibold text-[16px] md:text-center lg:text-[24px]">
                  {item?.title}
                </h6>
                <p className="font-lexend text-[11px] mt-1 text-[#B8B8B8] lg:text-[16px] md:text-center lg:mt-2">
                  {item?.desc}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default WellBeing;
